export default "__VITE_ASSET__XWc_cMma__"